import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const createMenuApi = (data) => {
  return httpService({
    url: contextPath + '/user/menu/item',
    method: 'post',
    data
  })
}

export const deleteMenuApi = (data) => {
  return httpService({
    url: contextPath + '/user/menu/item',
    method: 'delete',
    data
  })
}

export const updateMenuApi = (data) => {
  return httpService({
    url: contextPath + '/user/menu/item',
    method: 'put',
    data
  })
}

export const queryMenuApi = (params) => {
  return httpService({
    url: contextPath + '/user/menu/list',
    method: 'get',
    params
  })
}

export const getCurrentMenuByUser = (params) => {
  return httpService({
    url: contextPath + '/user/menu/list/currentUser',
    method: 'get',
    params
  })
}
